import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8421cfa1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-un-modal nge-un-modal--done"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "nge-un-title" }
const _hoisted_4 = { class: "nge-un-sub" }
const _hoisted_5 = { class: "nge-un-done-handle" }
const _hoisted_6 = {
  key: 1,
  class: "nge-un-modal"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "nge-un-title" }
const _hoisted_10 = { class: "nge-un-sub" }
const _hoisted_11 = { class: "nge-un-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-un-at" }, "@", -1 /* HOISTED */))
const _hoisted_13 = ["onKeydown"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "nge-un-actions" }
const _hoisted_19 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "nge-un" }, {
      default: _withCtx(() => [
        ($setup.visible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "nge-un-backdrop",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($setup.claimed ? null : $setup.dismiss()), ["self"]))
            }, [
              _createCommentVNode(" Success state: confirm the handle rather than just vanishing. "),
              ($setup.claimed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("img", {
                      src: $setup.pyrIcon,
                      class: "nge-un-icon nge-un-icon--done",
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, _toDisplayString($setup.mode === 'change' ? 'Username updated' : "You're locked in"), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_4, [
                      _createTextVNode(" Teammates can now tag you as "),
                      _createElementVNode("strong", null, "@" + _toDisplayString($setup.claimed), 1 /* TEXT */),
                      _createTextVNode(" in chat. You can change it any time in Settings. ")
                    ]),
                    _createElementVNode("div", _hoisted_5, "@" + _toDisplayString($setup.claimed), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("button", {
                      class: "nge-un-x",
                      onClick: $setup.dismiss,
                      title: $setup.mode === 'change' ? 'Cancel' : 'Not now'
                    }, "×", 8 /* PROPS */, _hoisted_7),
                    _createElementVNode("img", {
                      src: $setup.pyrIcon,
                      class: "nge-un-icon",
                      alt: ""
                    }, null, 8 /* PROPS */, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, _toDisplayString($setup.mode === 'change' ? 'Change your username' : 'Lock in your username'), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_10, [
                      _createTextVNode(" This is how you'll appear in chat, and how teammates tag you: "),
                      _createElementVNode("strong", null, "@" + _toDisplayString($setup.value || 'yourname'), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.value) = $event)),
                        class: "nge-un-input",
                        maxlength: "20",
                        spellcheck: "false",
                        autocomplete: "off",
                        placeholder: "yourname",
                        onInput: $setup.onInput,
                        onKeydown: [
                          _withKeys($setup.lockIn, ["enter"]),
                          _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        ]
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13), [
                        [_vModelText, $setup.value]
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["nge-un-note", { 'nge-un-note--err': $setup.error, 'nge-un-note--ok': $setup.ok && !$setup.error }])
                    }, [
                      ($setup.checking)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Checking…"))
                        : ($setup.error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.error), 1 /* TEXT */))
                          : ($setup.ok)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.ok), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, "3-20 characters. Letters, numbers and underscore."))
                    ], 2 /* CLASS */),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", {
                        class: "nge-un-save",
                        disabled: $setup.saving || !!$setup.error || !$setup.value.trim(),
                        onClick: $setup.lockIn
                      }, _toDisplayString($setup.saving ? 'Saving…' : ($setup.mode === 'change' ? 'Save username' : 'Lock it in')), 9 /* TEXT, PROPS */, _hoisted_19),
                      _createElementVNode("button", {
                        class: "nge-un-later",
                        onClick: $setup.dismiss
                      }, _toDisplayString($setup.mode === 'change' ? 'Cancel' : 'Not now'), 1 /* TEXT */)
                    ])
                  ]))
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}